<div class="container">
  <div class="door-list mt-3 mb-3" *ngIf="relayBoards.length > 0">
    <table class="table table-striped table-responsive-lg">
      <thead>
      <tr>
        <th scope="col">#</th>
        <th scope="col">Name</th>
        <th scope="col">Relays Count</th>
        <th scope="col">Office</th>
        <th scope="col">Host</th>
        <th scope="col">Port</th>
        <th></th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let relayBoard of relayBoards">
        <th scope="row">{{relayBoard.id}}</th>
        <td>{{relayBoard.name}}</td>
        <td>{{relayBoard.relayCount}}</td>
        <td>{{getOfficeName(relayBoard.officeId)}}</td>
        <td>{{relayBoard.host}}</td>
        <td>{{relayBoard.port}}</td>
        <td class="text-center">
          <button type="button" class="btn btn-light edit-button" (click)="openEditModal(relayBoard)">
            <i class="fas fa-pencil"></i>
          </button>
        </td>
        <td class="text-center">
          <button type="button" class="btn btn-danger delete-button" (click)="openDeleteConfirmModal(relayBoard)">
            <i class="fas fa-trash"></i>
          </button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
  <div class="text-center">
    <button type="button" class="btn btn-default add-button" (click)="openEditModal(null)">
      <i class="fas fa-plus"></i> Add new
    </button>
  </div>
</div>
